import { SubHeading } from "../../components/SubHeading/SubHeading"
import { pickup, travel } from "../../constants/images"
import './Transfers.css'

import { useDispatch } from 'react-redux'

import { useState } from 'react'


import { post_short_alert_message } from "../../../../../../actions/error_actions"
import { send_email_emailJs } from '../../../../../../actions/shared_actions'
import { Spinner } from "../../../../../sharable_components/small_components/alerts/loading"


export const TransfersMain = () => (
    <div>
        <Header />
        <TransferFormFill />
  </div>
)


const Header = () => (
    <div className="app__bg app__wrapper section__padding" id="home">
      <div className="app__wrapper_img">
        <img src={pickup} alt="header_img" />
      </div>
      <div className="app__wrapper_info">
        <SubHeading title="DGA Trasfer Services" />
        <h1 className="app__header-h1">Quick, Safe, Reliable</h1>
        <p className="p__opensans" style={{ margin: '2rem 0' }}> Wuold you like to have us pick you up from wherever you are? Fill the form below to request for our service. We are a call away, networked around the country for easy services. Welcome for long distance travel services</p>
        </div>
    </div>

  )


const TransferFormFill = () =>{ 
    const [load, set_load] = useState(false)

    const [form_errors, setForm_errors] = useState(null)
    const orig_email = {
        sys_user:"",
        sys_user_email:"",
        message:"",
        date: "",
        time: "",
        specific_details: "",
        pick_up: "",
        drop_off: "",
        message_category:"Transfer Request",
        sys_user_phone:"",
        final_message: ""
    }

    const [emailBody, setEmailBody] = useState(orig_email)
    const dispatch = useDispatch()

    const sendEmail = (e)=>{
        set_load(true)
        setForm_errors(null)
        e.preventDefault();
        if (validate_form(emailBody).length !==0) {
            setForm_errors(validate_form(emailBody))
            set_load(false)
        }
        else{
            send_email_emailJs({...emailBody, message:  `Date: ${emailBody.date} \n\n Time: ${emailBody.time}: ; \n\n Pick up point: ${emailBody.pick_up}; \n\n Drop off point: ${emailBody.drop_off}; \n\n Details: ${emailBody.message}`})
                .then((res)=>{
                    dispatch(post_short_alert_message({message:"Request sent successfully", type: 'success'}))
                    setEmailBody(orig_email)
                })
                .catch((e)=>dispatch(post_short_alert_message({message:"Sorry, There was a System Error. Try again Later", type: 'error'})))
                .finally(()=>set_load(false))
        }
    }

    
    return (

    <div className="app__footer section__padding" id="transferform">
        <form className="app__newsletter2"  onSubmit={e=>sendEmail(e)} onReset={e=>setEmailBody(orig_email)}>
            <div className="app__newsletter-heading">
                <SubHeading title="Transfer Form" />
                <h1 className="headtext__cormorant">Request for Transfer Service</h1>
                <p className="p__opensans">You will be contacted within minutes!</p>
                </div>
            
            <div className="app__newsletter-input flex__center">
                <div className="app__newsletter-input2 flex__center">
                    <label >Select the Pick-Up Date </label>
                    <input required type="date" value={emailBody.date} onChange={e=>setEmailBody({...emailBody, date:e.target.value})} />
                </div>
                <div className="app__newsletter-input2 flex__center">
                    <label >Select the Pick Up Time </label>
                    <input required type="time" placeholder="" value={emailBody.time} onChange={e=>setEmailBody({...emailBody, time:e.target.value})} />
                </div>
            </div>

            <div className="app__newsletter-input flex__center">
                <label >Enter Pick Up Location </label>
                <input required type="text" placeholder="eg Town/area/station/building" value={emailBody.pick_up} onChange={e=>setEmailBody({...emailBody, pick_up:e.target.value})} />
            </div>
            <div className="app__newsletter-input flex__center">
            <label >Enter Drop off Location </label>
                <input required type="text" placeholder="eg Town/area/station/building" value={emailBody.drop_off} onChange={e=>setEmailBody({...emailBody, drop_off:e.target.value})}/>
            </div>
            <div className="app__newsletter-input flex__center">
            <label >Enter More Description of service </label>
                <textarea type="text" placeholder="eg Car for 5 people, for quick service"  value={emailBody.message} onChange={e=>setEmailBody({...emailBody, message:e.target.value})} />
                
            </div>
            <div  className='align_right'>
                <small><i>{emailBody.message.replace(" ","").length} chars</i></small>
            </div>
            <div className="app__newsletter-input flex__center">
            <label>Full Name </label>
                <input required type="text" placeholder="Enter your Name" value={emailBody.sys_user} onChange={e=>setEmailBody({...emailBody, sys_user:e.target.value})}/>
            </div>
            <div className="app__newsletter-input flex__center">
            <label >Email Address </label>
                <input required type="email" placeholder="Enter your email address" value={emailBody.sys_user_email} onChange={e=>setEmailBody({...emailBody, sys_user_email:e.target.value})} />
            </div>
            <div className="app__newsletter-input flex__center">
            <label >Phone Number </label>
                <input required type="tel" placeholder="Enter your Phone Number" value={emailBody.sys_user_phone} onChange={e=>setEmailBody({...emailBody, sys_user_phone:e.target.value})} />
            </div>
            {form_errors && form_errors.map(e => 
                <div key={form_errors.indexOf(e)} className='form_errors'>
                    <small><li>{e}</li></small>
                    </div>
                )
                            }
            <div className="app__newsletter-input flex__center">
                <button type="submit" className="custom__button" onClick={e=>sendEmail(e)}>{load? <Spinner />: "Submit Request"}</button>
            </div>
        </form>
    </div>
)
    }



export const validate_form = (formData) => {
    const form_errors = []
    if (!formData?.sys_user_email?.split("@")[1]?.includes(".")) form_errors.push("Enter a valid email address")
    if (formData?.message.replace(" ","").length < 20) form_errors.push("Dscription must be more than 20 characters")
    if (formData?.sys_user_phone){
        if (formData?.sys_user_phone.length < 10 || isNaN(Number(formData?.sys_user_phone))) form_errors.push("Enter a valid phone number")
    }

    return form_errors
    
    }
    
